var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"showdoc"}},[_c('h1',[_vm._v("api说明文档")])])
}]

export { render, staticRenderFns }